module.exports = __webpack_public_path__ + "img/iot.a1ba4fee.gif";